import { createFileRoute } from "@tanstack/react-router"
import { QueryState } from "../components/layout/query-state"
import { ValueRecoveryRow } from "../components/settings/value-recovery-row"
import { Button } from "../components/ui/button"
import { useAuth } from "../hooks/use-auth"
import { useMarketplaces } from "../services/use-dashboard"

export function ValueRecoveryPage() {
  const marketplaces = useMarketplaces()
  const auth = useAuth()
  const canEdit = auth.user?.role === "admin" && !auth.isLoading && auth.error === null
  const editGuidance = canEdit
    ? "Changes save immediately when you use a switch."
    : "Only administrators can change these settings."
  return (
    <section aria-labelledby="value-recovery-title" className="max-w-4xl">
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 id="value-recovery-title" className="text-lg font-semibold">
            Value recovery
          </h2>

          <p className="mt-1 max-w-prose text-sm text-muted-foreground">
            Keep product values current and recheck affected runs automatically.
          </p>
        </div>

        <Button onClick={() => void marketplaces.refetch()} disabled={marketplaces.isFetching}>
          Refresh marketplaces
        </Button>
      </div>

      <p className="mb-4 max-w-prose text-sm text-muted-foreground">
        {`Each setting applies to its entire marketplace. The two settings are independent. ${editGuidance}`}
      </p>

      <QueryState
        isLoading={marketplaces.isLoading}
        error={marketplaces.error}
        isEmpty={marketplaces.data?.length === 0}
        emptyMessage="No marketplaces are configured."
      >
        <ul className="divide-y divide-border rounded-xl border border-border bg-card">
          {marketplaces.data?.map((marketplace) => (
            <ValueRecoveryRow key={marketplace} marketplace={marketplace} canEdit={canEdit} />
          ))}
        </ul>
      </QueryState>

      <div className="mt-4 max-w-prose space-y-2 text-sm text-muted-foreground">
        <p>
          Saved ON permits automatic work. It does not confirm worker health, progress, or recovered
          values.
        </p>

        <p>
          Missing historical records and changes needing explicit approval still require manual
          recovery. These settings do not create, prepare, approve, or submit listings.
        </p>
      </div>
    </section>
  )
}

export const Route = createFileRoute("/settings/value-recovery")({ component: ValueRecoveryPage })
